import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SendIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.01 6.03L11.52 9.25L4 8.25L4.01 6.03ZM11.51 14.75L4 17.97L4 15.75L11.51 14.75ZM2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3Z"
      fill="currentColor"
    />
  </svg>
);

SendIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SendIcon);
